
<div class="drawer" *ngIf="subclipsClipboard.items.length" [class.active]="drawerVisible">
  <div class="drawer-toggle" (click)="toggle()">
    <div class="text"><span translate>Subclips &nbsp;</span><span class="badge badge-info">{{subclipsClipboard.items.length}}</span><i class="far fa-arrow-up" *ngIf="!drawerVisible"></i><i class="far fa-arrow-down" *ngIf="drawerVisible"></i></div>
  </div>
  <div class="drawer-body">
    <entity-list [entities]="subclipsClipboard.items" [sortEntityPaths]="['-date']">
      <ng-template entityListItem let-item="entity">
        <div class="list-group-item combi double no-wrap w-100"><a class="list-group-main d-flex align-items-center no-wrap" routerLink="/media/view/{{root.id}}/{{item.cut.asset.id}}">
            <asset-thumbnail class="sm mr-3" [asset]="item.cut.asset" [time]="item.cut.tIn"></asset-thumbnail>
            <div [title]="item.cut.description || item.cut.asset.displayName">
              <div class="no-wrap">{{item.cut.name}}</div><code class="no-wrap">{{ item.cut.tIn|time:item.cut.asset.info.fps }} - {{ item.cut.tOut|time:item.cut.asset.info.fps }}</code>
            </div></a>
          <button class="btn btn-link reveal" (click)="subclipsClipboard.remove(item)"><i class="far fa-trash-alt"><span class="sr-only" translate>Remove</span></i></button>
        </div>
      </ng-template>
    </entity-list><br>
    <div class="btn-toolbar">
      <button class="btn btn-secondary" (click)="subclipsClipboard.clear()"><i class="far fa-times"></i><span translate>Clear clipboard</span></button>
    </div>
  </div>
</div>